<template>
  <div>
    <!-- ご利用方法 -->
    <h4>{{ note.default.title }}</h4>
    <ul>
      <li
        v-for="item in currentUsageContents"
        :key="item.noteContentText"
        class="newline"
      >
        {{ item.noteContentText }}
      </li>
    </ul>

    <!-- 注意事項 -->
    <h4>{{ note.caution.title }}</h4>
    <ul>
      <li
        v-for="item in note.caution.contents"
        :key="item.noteContentText"
        class="newline"
      >
        {{ item.noteContentText }}
      </li>
    </ul>
  </div>
</template>

<script>
import { FREE_FOOD_AFTER_LOGIN_URL, FREE_STAY_AFTER_LOGIN_URL } from "@/router/index.js";


export default {
  props: {
    note: {
      type: Object,
    }
  },
  computed: {
    currentUsageContents() {
      const currentPath = this.$route.path;
      // #73136対応 /premium-mobility-club/freeFoodAfterLoginと/premium-mobility-club/freeStayAfterLoginの場合のみ専用の文言を表示する
      if (
        currentPath === FREE_FOOD_AFTER_LOGIN_URL ||
        currentPath === FREE_STAY_AFTER_LOGIN_URL
      ) {
        return this.note.premiumMobilityClub?.contents || [];
      }
      return this.note.default?.contents || [];
    }
  }
};
</script>


<style lang="scss" scoped>
@import "@/assets/css/molecules/freeFood/info.scss";
</style>
